import { LitElement, html } from "lit";

import { customElement } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhBellSimple";

import { DataQueryController } from "ui-common/data-query-controller";
import type { GetNotificationsResult } from "api-contracts/rpc/notifications";
import { notificationsQueryOptions } from "ui-common/queries/notifications";

import { notificationBellStyles } from "./notification-bell.css";

@customElement("notification-bell")
export class NotificationBell extends LitElement {
  static override styles = notificationBellStyles;

  private notificationsController = new DataQueryController<GetNotificationsResult | null>(
    this,
    () => notificationsQueryOptions,
  );

  private _handleClick() {
    this.dispatchEvent(new CustomEvent("click", { bubbles: true, composed: true }));
  }

  protected override render() {
    const data = this.notificationsController?.result?.data as GetNotificationsResult | null | undefined;
    const unreadCount = data?.unreadCount !== undefined ? parseInt(data.unreadCount) : 0;

    return html`
      <div class="bell-container" @click=${this._handleClick}>
        <ph-bell-simple size="24"></ph-bell-simple>
        ${unreadCount > 0 ? html`<span class="badge">${unreadCount > 99 ? "99+" : unreadCount}</span>` : ""}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "notification-bell": NotificationBell;
  }
}
